export enum MFComponentEnum {
  EXAMPLE_COMPONENT = 'ExampleComponent',
}
